module.exports = __webpack_public_path__ + "static/button-right-b6a72cd0e780bdd6a15c44934be9f9ec.png";